const HelpDeskRequiredFields : any = []

export default HelpDeskRequiredFields
